import React, { useEffect, useState } from "react";
import { Col, Row, Button, Dropdown, ButtonGroup, Container } from '@themesberg/react-bootstrap';

import { PageVisitsTable } from "../../components/Tables";
import { trafficShares, totalOrders } from "../../data/charts";
import DataTable from "../components/optionTable";
import axiosInstance from "../../api/api";
import DataForm from "../components/DataFormOption";

export default () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchTableOption = async () => {
        try {
            const response = await axiosInstance.get('/option/'); // Endpoint del backend
            setData(response.data.data); // Guardar los datos del menú en el estado
            setLoading(false); // Indicar que la carga ha terminado
        } catch (error) {
            console.log(error.message); // Guardar el mensaje de error
            setLoading(false); // Indicar que la carga ha terminado
        }
    };

    // Obtener el menú al cargar el componente
    useEffect(() => {
        fetchTableOption();
    }, []);

    // Función para refrescar los datos después de agregar un nuevo registro
    const handleAdd = () => {
        fetchTableOption(); // Volver a obtener los datos actualizados del servidor
    };

    return (
        <Container className="mt-4">
            <div className="d-flex justify-content-between mb-3">
                <DataForm onAdd={handleAdd} />
            </div>
            <DataTable data={data} onAdd={handleAdd} />
        </Container>
    );
};
